import React, { useEffect, useState } from "react";

// import ThumbDetail from "../components/ThumbDetail";
// import { Link } from "react-router-dom";
import MovieBox from "../components/MovieBox";
import movieNotFound from "../assets/movieNotFound.png";
// import "bootstrap/dist/css/bootstrap.min.css";
// import {
//   Navbar,
//   Container,
//   Nav,
//   Form,
//   FormControl,
//   Button,
// } from "react-bootstrap";
const API_URL =
  "https://api.themoviedb.org/3/movie/popular?api_key=a7c761395a54cf211d4a190dbb18b4a5";
// const API_SEARCH =
//   "https://api.themoviedb.org/3/search/movie?api_key=a7c761395a54cf211d4a190dbb18b4a5&query";

const Movies = () => {
  const [movies, setMovies] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setMovies(data.results);
      });
  }, []);

  const searchMovie = async (e) => {
    e.preventDefault();
    console.log("Searching");
    try {
      const url = `https://api.themoviedb.org/3/search/movie?api_key=a7c761395a54cf211d4a190dbb18b4a5&query=${query}`;
      const res = await fetch(url);
      const data = await res.json();
      console.log(data);
      setMovies(data.results);
    } catch (e) {
      console.log(e);
    }
  };

  const changeHandler = (e) => {
    setQuery(e.target.value);
  };

  return (
    <div
      className="dark:bg-gray-100 bg-gray-800 text-white dark:text-black relative"
      name="movies"
    >
      <form action="justify-center items-center flex" onSubmit={searchMovie}>
        <div className="flex  text-center justify-center py-8">
          <input
            type="text"
            className="pl-5 p-2 mr-2 shadow-md rounded-[15px] w-1/3 focus:outline-none text-black"
            placeholder="Search for a movie..."
            onSubmit={searchMovie}
            value={query}
            onChange={changeHandler}
          />
          <button type="submit" className="border-2 p-2 flex items-center">
            <i class="fa fa-search "></i>
            <p className="mx-3">Search</p>
          </button>
        </div>
      </form>

      <div className="py-10 relative">
        {movies.length > 0 && movies !== "" ? (
          <div className="container  mx-auto">
            <div className="px-5">
              {/* <h3 className="md:decoration-dotted">Latest Movies</h3> */}
              <h3 className="mx-auto mb-3">MOVIES</h3>
            </div>
            <div className="grid lg:grid-cols-6  gap-4 sm:grid-cols-2 md:grid-cols-3">
              {movies.map((movieReq) => (
                <MovieBox key={movieReq.id} {...movieReq} />
              ))}
            </div>
          </div>
        ) : (
          // <h2 className="text-center items-center">Sorry !! No Movies Found</h2>
          <img
            src={movieNotFound}
            alt=""
            className="items-center justify-center text-center mx-auto"
          />
        )}
      </div>
    </div>
  );
};

export default Movies;
